import React, { memo } from 'react';

import { formatCurrency } from '@utils/formatter';

import styles from './StatusListCount.module.scss';

interface IStatusListCount {
	count: number;
	unit?: string;
	isTotal?: boolean;
}

const StatusListCount = ({
	count,
	unit,
	isTotal,
}: IStatusListCount) => {
	const countClassName = isTotal ? styles.totalCount : styles.itemCount;

	return <div className={styles.wrapper}>
		<div className={countClassName}>{unit ? formatCurrency(count) : count}</div>
	</div>;
};

export default memo(StatusListCount);
